import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from 'system/atoms/empty-states/EmptyState';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';
import { pathsV2Creators } from 'core/services/navigation/usePathsV2';

interface SourcingCandidatesEmptyStateProps {
  candidateBatchId?: string;
  isFiltering?: boolean;
}

export const SourcingCandidatesEmptyState: React.FC<
  SourcingCandidatesEmptyStateProps
> = ({ candidateBatchId, isFiltering = false }) => {
  const { track } = useTracking();
  const navigate = useNavigate();

  const handleSourceCandidates = () => {
    if (!candidateBatchId) return;

    track(TrackingEventName.AnalyseDashboardSourceFromBlank, {
      candidateBatchId
    });

    navigate(
      pathsV2Creators.ANALYSE_SOURCE_EXTERNAL_CANDIDATES({
        candidateBatchId
      })
    );
  };

  if (isFiltering) {
    return <EmptyState type="no-results" />;
  }

  return (
    <EmptyState
      type="no-records"
      title="No candidates invited"
      subtitle={
        candidateBatchId
          ? 'Search our database of professionals and boost your applicant count.'
          : undefined
      }
      buttonText={candidateBatchId ? 'Source candidates now' : undefined}
      onButtonClick={candidateBatchId ? handleSourceCandidates : undefined}
    />
  );
};
